import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { IContact } from "src/app/models/contact/contact";
import { ContactService } from "src/app/services/contact.service";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-search-contact-modal",
  templateUrl: "./search-contact-modal.component.html",
  styleUrls: ["./search-contact-modal.component.scss"],
})
export class SearchContactModalComponent implements OnInit {
  @Output() select = new EventEmitter<IContact>();
  @Output() close = new EventEmitter();

  contacts: IContact[] = [];
  pageNumber = "1";
  searchString = "";

  private readonly _pageSize = "10";

  constructor(
    private readonly _modalService: ModalService,
    private readonly _contactService: ContactService
  ) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.SearchContact;
  }

  getContacts() {
    return this._contactService
      .getAll({ pageNumber: this.pageNumber, pageSize: this._pageSize, searchString: this.searchString })
      .subscribe(contacts => {
        this.contacts = contacts.records;
      });
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  handleSelect(contact: IContact) {
    this._modalService.closeModal();
    this.select.emit(contact);
  }

  ngOnInit() {
    this.getContacts();
  }
}
